if (!customElements.get('bestseller-countdown-timer')) {
  const MAX_VISIBLE_RANGE_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

  customElements.define(
    'bestseller-countdown-timer',
    class BestsellerCountdownTimer extends HTMLElement {
      connectedCallback() {
        this.endTime = new Date(this.dataset.end).getTime();
        this.daysEl = this.querySelector('[data-days]');
        this.hoursEl = this.querySelector('[data-hours]');
        this.minutesEl = this.querySelector('[data-minutes]');
        this.secondsEl = this.querySelector('[data-seconds]');

        const diff = this.endTime - Date.now();

        // Hide rather than show a stale/meaningless countdown if the merchant
        // forgot to update the end date, or set one too far in the future.
        if (isNaN(this.endTime) || diff <= 0 || diff > MAX_VISIBLE_RANGE_MS) {
          this.classList.add('hidden');
          return;
        }

        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        if (this.interval) clearInterval(this.interval);
      }

      tick() {
        const diff = this.endTime - Date.now();

        if (diff <= 0) {
          this.setUnits(0, 0, 0, 0);
          clearInterval(this.interval);
          return;
        }

        const days = Math.floor(diff / 86400000);
        const hours = Math.floor((diff % 86400000) / 3600000);
        const minutes = Math.floor((diff % 3600000) / 60000);
        const seconds = Math.floor((diff % 60000) / 1000);
        this.setUnits(days, hours, minutes, seconds);
      }

      setUnits(days, hours, minutes, seconds) {
        if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
        if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
        if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
        if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
      }
    }
  );
}
